import { z } from 'zod/v4';
export var Market;
(function (Market) {
    Market["ARE"] = "ARE";
    Market["ARG"] = "ARG";
    Market["AUS"] = "AUS";
    Market["AUT"] = "AUT";
    Market["BEL"] = "BEL";
    Market["BGR"] = "BGR";
    Market["BHR"] = "BHR";
    Market["BOL"] = "BOL";
    Market["BRA"] = "BRA";
    Market["CAN"] = "CAN";
    Market["CHE"] = "CHE";
    Market["CHL"] = "CHL";
    Market["CHN"] = "CHN";
    Market["COL"] = "COL";
    Market["CRI"] = "CRI";
    Market["CUW"] = "CUW";
    Market["CYM"] = "CYM";
    Market["CYP"] = "CYP";
    Market["DEU"] = "DEU";
    Market["DNK"] = "DNK";
    Market["DOM"] = "DOM";
    Market["ECU"] = "ECU";
    Market["EGY"] = "EGY";
    Market["ESP"] = "ESP";
    Market["EST"] = "EST";
    Market["FIN"] = "FIN";
    Market["FRA"] = "FRA";
    Market["GBR"] = "GBR";
    Market["GLP"] = "GLP";
    Market["GRC"] = "GRC";
    Market["GTM"] = "GTM";
    Market["GUF"] = "GUF";
    Market["HKG"] = "HKG";
    Market["HRV"] = "HRV";
    Market["HUN"] = "HUN";
    Market["IND"] = "IND";
    Market["IRL"] = "IRL";
    Market["ISR"] = "ISR";
    Market["ITA"] = "ITA";
    Market["JAM"] = "JAM";
    Market["JOR"] = "JOR";
    Market["JPN"] = "JPN";
    Market["KOR"] = "KOR";
    Market["KWT"] = "KWT";
    Market["LBN"] = "LBN";
    Market["LCA"] = "LCA";
    Market["LTU"] = "LTU";
    Market["LUX"] = "LUX";
    Market["LVA"] = "LVA";
    Market["MAR"] = "MAR";
    Market["MEX"] = "MEX";
    Market["MTQ"] = "MTQ";
    Market["NLD"] = "NLD";
    Market["NOR"] = "NOR";
    Market["NZL"] = "NZL";
    Market["OMN"] = "OMN";
    Market["PAN"] = "PAN";
    Market["PER"] = "PER";
    Market["POL"] = "POL";
    Market["PRT"] = "PRT";
    Market["PRY"] = "PRY";
    Market["QAT"] = "QAT";
    Market["ROU"] = "ROU";
    Market["RUS"] = "RUS";
    Market["SAU"] = "SAU";
    Market["SRB"] = "SRB";
    Market["SGP"] = "SGP";
    Market["SLV"] = "SLV";
    Market["SVK"] = "SVK";
    Market["SWE"] = "SWE";
    Market["SXM"] = "SXM";
    Market["THA"] = "THA";
    Market["TTO"] = "TTO";
    Market["TUR"] = "TUR";
    Market["TWN"] = "TWN";
    Market["URY"] = "URY";
    Market["USA"] = "USA";
    Market["VAT"] = "VAT";
    Market["VEN"] = "VEN";
    Market["VNM"] = "VNM";
    Market["ZAF"] = "ZAF";
})(Market || (Market = {}));
export const MarketSchema = z.enum(Object.values(Market));
export const defaultLanguageFor = (market) => orderedLanguagesPerMarket[market][0];
export const orderedLanguagesPerMarket = {
    [Market.ARE]: ['en'],
    [Market.ARG]: ['es'],
    [Market.AUS]: ['en'],
    [Market.AUT]: ['de'],
    [Market.BEL]: ['fr', 'nl'],
    [Market.BGR]: ['bg'],
    [Market.BHR]: ['en'],
    [Market.BOL]: ['es'],
    [Market.BRA]: ['pt'],
    [Market.CAN]: ['en', 'fr'],
    [Market.CHE]: ['de', 'it', 'fr'],
    [Market.CHL]: ['es'],
    [Market.CHN]: ['zh'],
    [Market.COL]: ['es'],
    [Market.CRI]: ['es'],
    [Market.CUW]: ['en', 'nl'],
    [Market.CYM]: ['en'],
    [Market.CYP]: ['el', 'tr'],
    [Market.DEU]: ['de'],
    [Market.DNK]: ['da'],
    [Market.DOM]: ['es'],
    [Market.ECU]: ['es'],
    [Market.EGY]: ['en'],
    [Market.ESP]: ['es'],
    [Market.EST]: ['et'],
    [Market.FIN]: ['fi'],
    [Market.FRA]: ['fr'],
    [Market.GBR]: ['en'],
    [Market.GLP]: ['fr'],
    [Market.GRC]: ['el'],
    [Market.GTM]: ['es'],
    [Market.GUF]: ['fr'],
    [Market.HKG]: ['en'],
    [Market.HRV]: ['hr'],
    [Market.HUN]: ['hu'],
    [Market.IND]: ['en'],
    [Market.IRL]: ['en'],
    [Market.ISR]: ['en'],
    [Market.ITA]: ['it'],
    [Market.JAM]: ['en'],
    [Market.JOR]: ['en'],
    [Market.JPN]: ['ja'],
    [Market.KOR]: ['ko'],
    [Market.KWT]: ['en'],
    [Market.LBN]: ['en'],
    [Market.LCA]: ['en'],
    [Market.LTU]: ['lt', 'ru'],
    [Market.LUX]: ['de', 'fr'],
    [Market.LVA]: ['lv', 'ru'],
    [Market.MAR]: ['en'],
    [Market.MEX]: ['es'],
    [Market.MTQ]: ['fr'],
    [Market.NLD]: ['nl'],
    [Market.NOR]: ['no'],
    [Market.NZL]: ['en'],
    [Market.OMN]: ['en'],
    [Market.PAN]: ['es'],
    [Market.PER]: ['es'],
    [Market.POL]: ['pl'],
    [Market.PRT]: ['pt'],
    [Market.PRY]: ['es'],
    [Market.QAT]: ['en'],
    [Market.ROU]: ['ro'],
    [Market.RUS]: ['ru'],
    [Market.SAU]: ['en'],
    [Market.SRB]: ['rs'],
    [Market.SGP]: ['en'],
    [Market.SLV]: ['es'],
    [Market.SVK]: ['sk'],
    [Market.SWE]: ['sv'],
    [Market.SXM]: ['en', 'nl'],
    [Market.THA]: ['th', 'en'],
    [Market.TTO]: ['en'],
    [Market.TUR]: ['tr'],
    [Market.TWN]: ['zh'],
    [Market.URY]: ['es'],
    [Market.USA]: ['en'],
    [Market.VAT]: ['en'],
    [Market.VEN]: ['en'],
    [Market.VNM]: ['en'],
    [Market.ZAF]: ['en'],
};
export const marketToTwoLettercode = {
    [Market.ARE]: 'AE',
    [Market.ARG]: 'AR',
    [Market.AUS]: 'AU',
    [Market.AUT]: 'AT',
    [Market.BEL]: 'BE',
    [Market.BGR]: 'BG',
    [Market.BHR]: 'BH',
    [Market.BOL]: 'BO',
    [Market.BRA]: 'BR',
    [Market.CAN]: 'CA',
    [Market.CHE]: 'CH',
    [Market.CHL]: 'CL',
    [Market.CHN]: 'CN',
    [Market.COL]: 'CO',
    [Market.CRI]: 'CR',
    [Market.CUW]: 'CW',
    [Market.CYM]: 'KY',
    [Market.CYP]: 'CY',
    [Market.DEU]: 'DE',
    [Market.DNK]: 'DK',
    [Market.DOM]: 'DO',
    [Market.ECU]: 'EC',
    [Market.EGY]: 'EG',
    [Market.ESP]: 'ES',
    [Market.EST]: 'EE',
    [Market.FIN]: 'FI',
    [Market.FRA]: 'FR',
    [Market.GBR]: 'GB',
    [Market.GLP]: 'GP',
    [Market.GRC]: 'GR',
    [Market.GTM]: 'GT',
    [Market.GUF]: 'GF',
    [Market.HKG]: 'HK',
    [Market.HRV]: 'HR',
    [Market.HUN]: 'HU',
    [Market.IND]: 'IN',
    [Market.IRL]: 'IE',
    [Market.ISR]: 'IL',
    [Market.ITA]: 'IT',
    [Market.JAM]: 'JM',
    [Market.JOR]: 'JO',
    [Market.JPN]: 'JP',
    [Market.KOR]: 'KR',
    [Market.KWT]: 'KW',
    [Market.LBN]: 'LB',
    [Market.LCA]: 'LC',
    [Market.LTU]: 'LT',
    [Market.LUX]: 'LU',
    [Market.LVA]: 'LV',
    [Market.MAR]: 'MA',
    [Market.MEX]: 'MX',
    [Market.MTQ]: 'MQ',
    [Market.NLD]: 'NL',
    [Market.NOR]: 'NO',
    [Market.NZL]: 'NZ',
    [Market.OMN]: 'OM',
    [Market.PAN]: 'PA',
    [Market.PER]: 'PE',
    [Market.POL]: 'PL',
    [Market.PRT]: 'PT',
    [Market.PRY]: 'PY',
    [Market.QAT]: 'QA',
    [Market.ROU]: 'RO',
    [Market.RUS]: 'RU',
    [Market.SAU]: 'SA',
    [Market.SRB]: 'RS',
    [Market.SGP]: 'SG',
    [Market.SLV]: 'SV',
    [Market.SVK]: 'SK',
    [Market.SWE]: 'SE',
    [Market.SXM]: 'SX',
    [Market.THA]: 'TH',
    [Market.TTO]: 'TT',
    [Market.TUR]: 'TR',
    [Market.TWN]: 'TW',
    [Market.URY]: 'UY',
    [Market.USA]: 'US',
    [Market.VAT]: 'VA',
    [Market.VEN]: 'VE',
    [Market.VNM]: 'VN',
    [Market.ZAF]: 'ZA',
};
//# sourceMappingURL=market.js.map